module.exports = __webpack_public_path__ + "media/images/weather/20_day-6107080bf64653bea415b42f6f0b1bbc.png";